module.exports = __webpack_public_path__ + "img/transparent_ppt.d2a02ecf.svg";